import React from "react";

// Original circular emblem inspired by a prison-bars motif.
export const Logo = ({ className = "h-20 w-20" }) => {
  return (
    <div className={`relative ${className}`}>
      <svg viewBox="0 0 120 120" className="h-full w-full">
        <defs>
          <radialGradient id="lgRing" cx="50%" cy="40%" r="70%">
            <stop offset="0%" stopColor="#6b6b6b" />
            <stop offset="60%" stopColor="#3d3d3d" />
            <stop offset="100%" stopColor="#1a1a1a" />
          </radialGradient>
          <linearGradient id="lgBar" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#f2d089" />
            <stop offset="100%" stopColor="#caa14a" />
          </linearGradient>
          <clipPath id="lgClip">
            <circle cx="60" cy="60" r="48" />
          </clipPath>
        </defs>

        {/* outer metal ring */}
        <circle cx="60" cy="60" r="57" fill="#1a1a1a" />
        <circle cx="60" cy="60" r="57" fill="none" stroke="#7a7a7a" strokeWidth="3" />
        <circle cx="60" cy="60" r="50" fill="url(#lgRing)" />

        {/* rivets */}
        {Array.from({ length: 12 }).map((_, i) => {
          const a = (i / 12) * Math.PI * 2;
          const x = 60 + Math.cos(a) * 53.5;
          const y = 60 + Math.sin(a) * 53.5;
          return <circle key={i} cx={x} cy={y} r="1.6" fill="#9a9a9a" />;
        })}

        {/* interior scene: cell with light */}
        <g clipPath="url(#lgClip)">
          <rect x="12" y="12" width="96" height="96" fill="#111" />
          <ellipse cx="60" cy="30" rx="26" ry="20" fill="#2c2c2c" />
          {[38, 50, 62, 74].map((x) => (
            <rect key={x} x={x} y="20" width="4" height="44" fill="#cfcfcf" opacity="0.85" />
          ))}
        </g>

        {/* INCARCERATED banner text */}
        <text
          x="60"
          y="78"
          textAnchor="middle"
          fontFamily="Oswald, sans-serif"
          fontWeight="700"
          fontSize="13"
          fill="url(#lgBar)"
          letterSpacing="0.5"
        >
          INCARCERATED
        </text>
        {/* handcuff hint */}
        <g stroke="#b9b9b9" strokeWidth="3" fill="none">
          <circle cx="48" cy="96" r="7" />
          <circle cx="72" cy="96" r="7" />
          <line x1="55" y1="96" x2="65" y2="96" />
        </g>
      </svg>
    </div>
  );
};
